export default __webpack_public_path__ + "static/media/services_hospitality.3daba7b1.jpg";